/*
 *
 *  sagas
 *
 */

import { call, take, put, race, select, all, delay } from "redux-saga/effects"

import {
  LOAD_RECORDS_META_DATA,
  UPDATE_SALES_QC_REAPPROVE,
  APPROVE_SALES_QC_REQUEST,
  LOAD_SALES_PENDING,
  LOAD_SALES_QC_HISTORY,

} from "./constants"

import {
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  loadSalesPending,
  loadSalesPendingSuccess,
  loadSalesPendingError,
  loadSalesQcHistory,
  loadSalesQcHistorySuccess,
  approvalSalesRequestQcSuccess,
  approvalSalesRequestQcError,
  updateSalesQcReapproveSuccess,
  updateSalesQcReapproveError,
  loadSalesQcHistoryError,
} from "./actions"

import {
  loadRecordsMetaData,
  loadSalesPendingDetails,
  loadSalesQcHistoryDetails,
  approvalSalesRequestQc,
  updateSalesReapproveQc,
  
  
} from "./remotes"

import { selectSession } from "../session/selectors"
import { roleIds } from "../../helpers/tools"


// Sales Pending approval Saga

function* loadSalesPendingSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_SALES_PENDING),
    })

    const { explicitLoad } = load

    const {  searchValue } = explicitLoad || {}
    yield put(loadSalesPending(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadSalesPendingDetails, searchValue)

        if (result) {
          yield put(loadSalesPendingSuccess(result.data))
        } else {
          yield put(loadSalesPendingSuccess([]))
          yield put(loadSalesPendingError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadSalesPendingSuccess([]))
        yield put(
          loadSalesPendingError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

// Qc history Saga

function* loadSalesQcHistorySaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_SALES_QC_HISTORY),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadSalesQcHistory(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadSalesQcHistoryDetails, id)

        if (result) {
          yield put(loadSalesQcHistorySuccess(result.data))
        } else {
          yield put(loadSalesQcHistoryError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadSalesQcHistoryError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

//Qc approval request

function* approvalSalesRequestSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { approve } = yield race({
      approve: take(APPROVE_SALES_QC_REQUEST),
    })
    const { leadId, leadQuotationId, salesId } = approve || {}
    if (approve) {
      try {
        yield call(approvalSalesRequestQc, leadId, leadQuotationId, salesId)
        // yield delay(1000)
        yield put(
          approvalSalesRequestQcSuccess(
            leadId,
            leadQuotationId,
            "Record Deleted Successfully"
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          approvalSalesRequestQcError(
            (error && error.response && error.response.message) ||
              "Delete Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

//Qc Re approval request

function* updateSalesReapprovalQcSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { approve } = yield race({
      approve: take(UPDATE_SALES_QC_REAPPROVE),
    })
    const { qcUpdateData } = approve || {}
    if (approve) {
      try {
        yield call(updateSalesReapproveQc, qcUpdateData)
        // yield delay(1000)
        yield put(
          updateSalesQcReapproveSuccess(
            qcUpdateData,
            "Record Deleted Successfully"
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          updateSalesQcReapproveError(
            (error && error.response && error.response.message) ||
              "Delete Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
      let sessionDetails
      while (true) {
        // eslint-disable-line no-constant-condition
        const sessionInStore = yield select(selectSession())

        const { user = {} } = sessionInStore
        if (user && Object.keys(user).length > 0) {
          sessionDetails = sessionInStore
          break
        }
        yield delay(500)
      }

      let company
      let branch
      if (
        sessionDetails &&
        sessionDetails.user &&
        roleIds.includes(sessionDetails.user.roleId)
      ) {
        company = yield call(loadRecordsMetaData, "company", "post")
        branch = yield call(loadRecordsMetaData, "branch", "post")
      } else {
        company =
          (sessionDetails &&
            sessionDetails.user &&
            sessionDetails.user.company &&
            sessionDetails.user.company.length > 0 &&
            sessionDetails.user.company.map((_) => _.detail)) ||
          []
        branch =
          (sessionDetails &&
            sessionDetails.user &&
            sessionDetails.user.branch &&
            sessionDetails.user.branch.length > 0 &&
            sessionDetails.user.branch.map((_) => _.detail)) ||
          []
      }
      const service = yield call(loadRecordsMetaData, "service", "post")
      const priorityStatus = yield call(loadRecordsMetaData, "priority", "post")
      const employeeFilter = yield call(loadRecordsMetaData, "employee_filter", "post")
      
      let recordsMetaData = {
        companyOptions:
          (company &&
            company.data &&
            company.data.length > 0 &&
            company.data.filter(_=>_.status === 1).map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          (company &&
            company.length > 0 &&
            company.map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          [],
        branchOptions:
          (branch &&
            branch.data &&
            branch.data.length > 0 &&
            branch.data.filter(_=>_.status === 1).map((c) =>
              Object.assign(
                {},
                { label: c.name, value: c._id, companyId: c.companyId }
              )
            )) ||
          (branch &&
            branch.length > 0 &&
            branch.map((c) =>
              Object.assign(
                {},
                { label: c.name, value: c._id, companyId: c.companyId }
              )
            )) ||
          [],
          priorityOptions:
          (priorityStatus &&
            priorityStatus.data &&
            priorityStatus.data.length > 0 &&
            priorityStatus.data.filter(_=>_.status === 1).map((c) =>
              Object.assign({}, { label: c.priority, value: c._id })
            )) ||
          [],
          employeeOptions:
          (employeeFilter &&
            employeeFilter.data &&
            employeeFilter.data.length > 0 &&
            employeeFilter.data.filter(_=>_.status === 1).map((c) =>
              Object.assign(
                {},
                { label: c.name, value: c._id, empCode: c.empCode, companyId: c.companyId }
              )
            )) ||
          [],
          serviceOptions:
          (service &&
            service.data &&
            service.data.length > 0 &&
            service.data.filter(_=>_.status === 1).map((c) =>
              Object.assign(
                {},
                { label: c.service, value: c._id, companyId: c.companyId }
              )
            )) ||
          [],

      }

      yield put(loadRecordsMetaDataSuccess(recordsMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}


export default function* recordsSaga() {
  yield all([
    loadRecordsMetaDataSaga(),
    loadSalesPendingSaga(),
    loadSalesQcHistorySaga(),
    approvalSalesRequestSaga(),
    updateSalesReapprovalQcSaga(), 
  ])
}
